import axios from 'axios';

const { NODE_ENV, APP_PUBLIC_ADDRESS, API_BASE_URL } = process.env;

const getPublicAddress = () => {
  switch (NODE_ENV) {
    case 'development':
      return APP_PUBLIC_ADDRESS || 'http://localhost:3001';
    default:
      return APP_PUBLIC_ADDRESS || '';
  }
};

export const publicUrl = getPublicAddress();

export const baseUrl = API_BASE_URL || `${publicUrl}/api/v1`;

const api = axios.create({
  baseURL: baseUrl,
});

export default api;
